import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

// this command triggers one or more events, see base-command for rules
class Command extends Base<any> {

    static about = `Invokes destroy on the maplet`;
    
    execute(args: any = this.args) {
        this.mediator.api.destroy();
        this.trigger();
    }

}

export = Command; 